<!--
 * @Description: 根节点
 * @Autor: zczhang
 * @Date: 2020-07-06 21:43:30
 * @LastEditors: zczhang
 * @LastEditTime: 2020-11-25 15:29:46
-->
<template>
  <div
    id="app"
    class="app"
  >
    <!--    <indexPage/>-->
    <router-view></router-view>
  </div>
</template>
<script>
import indexPage from './Index'
import { mapMutations, mapGetters } from 'vuex'

export default {
    name: 'App',
    data() {
        return {
            hasLogin: true,
            gpsList: [],
            warningData: [],
            onlineList: [], // gps在线设备列表
            offlineList: [], // gps离线设备列表
            sbChannel: {}, // 设备第二通道集合
        }
    },
    components: {
        indexPage,
    },
    created: async function () {
        this.hasLogin = false
        let _this = this
        // initData()
        // validateAndInitData()

        // 登陆及初始化页面数据
        function validateAndInitData() {
            _this.FUNCTIONS.systemFunction.commonGet(
                _this.CONFIG.urls.root + _this.CONFIG.urls.index.login,
                (result) => {
                    if (
                        result.code === _this.GLOBAL.config.resultCode.notLogin
                    ) {
                        window.location.href = result.data
                    } else if (
                        result.code === _this.GLOBAL.config.resultCode.success
                    ) {
                        // 基本数据缓存-----start--------------
                        let userInfo = result.data.userInfo,
                            dictionaryList = result.data.dictionaryList
                        userInfo &&
                            localStorage.setItem(
                                _this.GLOBAL.config.userConfigName,
                                JSON.stringify(userInfo)
                            )
                        dictionaryList && dictionaryCache(dictionaryList)
                        // 基本数据缓存-----end----------------

                        _this.hasLogin = true
                    } else if (
                        typeof result === _this.GLOBAL.config.dataType.string
                    ) {
                        validateAndInitData()
                    } else {
                        _this.$message.error('登陆校验失败～请联系管理员')
                    }
                }
            )
        }
        // 初始化缓存数据
        // function initData() {
        //     let param = {
        //         baseService: 'TSysZdServiceImpl',
        //         type: 'getAll'
        //     }
        //     _this.FUNCTIONS.systemFunction.jsonPost(
        //         _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
        //         param,
        //         result => {
        //             console.log(result)
        //             if (result.code === '200') {
        //                 // let dic = result.obj[0]
        //                 cacheDictionaryData(result.obj)
        //             } else {
        //                 _this.$message.error('获取字典数据失败！')
        //             }
        //         },
        //         err => {
        //             _this.$message.error('获取字典数据失败！请联系管理员！')
        //         }
        //     )
        // }
        // // 缓存字典数据
        // function cacheDictionaryData(dictionary) {
        //     let nameList = Object.keys(dictionary)
        //     localStorage.setItem('cacheHistory', 'cacheHistory')
        //     nameList.forEach(item => {
        //         console.log(item)
        //         localStorage.setItem(
        //             item,
        //             escape(JSON.stringify(dictionary[item]))
        //         )
        //     })
        // }

        // 缓存字典数据
        function dictionaryCache(dictionaryList) {
            if (dictionaryList && dictionaryList.length > 0) {
                let parents = dictionaryList.filter((item) => !item.parentCode)
                parents &&
                    parents.length > 0 &&
                    parents.forEach((dictionary) => {
                        let _parentCode = dictionary.code
                        let dictionaryDetails = dictionaryList
                            .filter((item) => item.parentCode === _parentCode)
                            .sort((a, b) => a.sort - b.sort)
                        localStorage.removeItem(
                            _this.GLOBAL.config.dictionaryPre + _parentCode
                        )
                        localStorage.setItem(
                            _this.GLOBAL.config.dictionaryPre + _parentCode,
                            escape(JSON.stringify(dictionaryDetails))
                        )
                    })
            }
        }
    },
    methods: {
        ...mapMutations({
            setGps: 'common/setGps',
            setWarningData: 'common/setWarningData',
            setOnlineParam: 'common/setOnlineParam',
        }),
        getWarningData() {
            let _this = this
            setTimeout(function () {
                // 在线设备
                _this.onlineList = _this.jswSession._arr_pu_online.filter(
                    (item) => item._arr_tsp.length == 2
                )
                console.log(_this.onlineList)
                localStorage.setItem('onlineList', _this.onlineList)
                _this.setOnlineParam(_this.onlineList)
                // 离线设备
                _this.offlineList = _this.jswSession._arr_pu_offline.filter(
                    (item) => item._arr_tsp.length == 2
                )
                console.log(_this.offlineList)
                _this.gpsList = []
                for (let i = 0; i < _this.onlineList.length; i++) {
                    _this.gpsList.push({
                        yjSb: _this.onlineList[i]._id_pu,
                        pulName: _this.onlineList[i]._name_pu,
                    })
                }
                _this.gpsWebsocketInit()
            }, 2000)
        },
        getWarningList() {
            //登陆后才有
            let userInfo = localStorage.getItem('gcUserInfo')
                ? JSON.parse(localStorage.getItem('gcUserInfo'))
                : null
            if (userInfo) {
                let { yhqx, ssqhmc, ssqhdm } = userInfo
                //县或管理员接口区域参数置空
                if (yhqx == 3 || yhqx == 5) {
                    this.FUNCTIONS.systemFunction.interactiveData(
                        this,
                        this.GLOBAL.config.businessFlag.zxUser,
                        'yj',
                        {
                            baseService: 'TGcYjServiceImpl',
                            yjType: 1,
                            ssqhdm: '',
                        },
                        null,
                        (resultData) => {
                            let { obj } = resultData
                            if (obj.length) {
                                this.setWarningData({ data: obj })
                            }
                        },
                        () => {}
                    )
                } else if (yhqx == 4) {
                    this.FUNCTIONS.systemFunction.interactiveData(
                        this,
                        this.GLOBAL.config.businessFlag.zxUser,
                        'yj',
                        {
                            baseService: 'TGcYjServiceImpl',
                            yjType: 1,
                            ssqhdm: ssqhdm,
                        },
                        null,
                        (resultData) => {
                            let { obj } = resultData
                            if (obj.length) {
                                this.setWarningData({ data: obj })
                            }
                        },
                        () => {}
                    )
                }
            }
        },
        // 初始化缓存数据
        initData() {
            let _this = this
            let param = {
                baseService: 'TSysZdServiceImpl',
                type: 'getAll',
            }
            _this.FUNCTIONS.systemFunction.jsonPost(
                _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                param,
                (result) => {
                    console.log(result)
                    if (result.code === '200') {
                        // let dic = result.obj[0]
                        _this.cacheDictionaryData(result.obj)
                    } else {
                        _this.$message.error('获取字典数据失败！')
                    }
                },
                (err) => {
                    _this.$message.error('获取字典数据失败！请联系管理员！')
                }
            )
        },
        // 缓存字典数据
        cacheDictionaryData(dictionary) {
            let nameList = Object.keys(dictionary)
            localStorage.setItem('cacheHistory', 'cacheHistory')
            nameList.forEach((item) => {
                localStorage.setItem(
                    item,
                    escape(JSON.stringify(dictionary[item]))
                )
            })
        },
        getXzList() {
            let _this = this
            let param = {
                baseService: 'TGcOrganizationServiceImpl',
                type: 'getXzList',
            }
            _this.FUNCTIONS.systemFunction.jsonPost(
                _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                param,
                (resultData) => {
                    if (resultData) {
                        localStorage.setItem(
                            'xzList',
                            JSON.stringify(resultData.obj)
                        )
                    } else {
                    }
                }
            )
        },
        getAllCLSBList() {
            let _this = this
            let param = {
                baseService: 'TGcSbServiceImpl',
                type: 'getAll',
            }
            _this.FUNCTIONS.systemFunction.jsonPost(
                _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                param,
                (resultData) => {
                    if (resultData) {
                        localStorage.setItem(
                            'clsbList',
                            JSON.stringify(resultData.obj)
                        )
                    } else {
                    }
                }
            )
        },
        //初始化WS连接
        gpsWebsocketInit() {
            // debugger
            if (this.jswSession == null) {
                return false
            }
            // let deviceList = this.gpsList
            let wsInstanceArr = []
            this.gpsList.forEach((item) => {
                let wsInstance = this.jswSession.swGetPuChanel(item.yjSb, 65536)
                if (!wsInstance) return
                // 判断设备通道是否打开，m_is_open: false关闭 true打开，通道已打开则先关闭后再重新打开（防止设备下线后重新上线获取不到gps）
                if (wsInstance.m_is_open) {
                    wsInstance.swClose()
                }
                if (item.yjSb === 'PU_3DAE') {
                    console.log('++++++++++++++++++++')
                    console.log(wsInstance)
                    console.log('++++++++++++++++++++')
                }
                wsInstance.swOpen({
                    repeat: -1,
                    interval: 4000,
                    callback: (options, response) => {
                        if (response.gps) {
                            let {
                                gps: { lat, long },
                            } = response
                            let markLong = `${long}`.split('')
                            markLong.splice(3, 0, '.')
                            let markLat = `${lat}`.split('')
                            markLat.splice(2, 0, '.')
                            this.setGps({
                                pulName: item.pulName,
                                name: item.yjSb,
                                gps: [markLong.join(''), markLat.join('')],
                            })
                        }
                    },
                })
            })
        },
        //初始化从ws取得预警信息
        initWarningInfo() {
            let isregnotify = false
            if (!isregnotify) {
                this.jswSession.swAddCallBack(
                    'notify',
                    (sender, event, json) => {
                        if (json) {
                            let {
                                content: { iEventType, szID },
                            } = json
                            //等于4099则为报警
                            // if (iEventType == 4099) {
                            //   let gpsData = this.getGps
                            //   debugger
                            // }
                            let gpsData = this.getGps
                        }
                        isregnotify = true
                    }
                )
            }
        },
        // 获取倾倒点坐标list
        getQddGps() {
            let _this = this
            let userInfo = localStorage.getItem('gcUserInfo')
                ? JSON.parse(localStorage.getItem('gcUserInfo'))
                : null
            if (userInfo) {
                let param = {
                    baseService: 'TGcQddServiceImpl',
                    type: 'getListByCondition',
                }
                _this.FUNCTIONS.systemFunction.jsonPost(
                    _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                    param,
                    (result) => {
                        console.log(result)
                        if (result.code === '200') {
                            localStorage.setItem(
                                'qddList',
                                JSON.stringify(result.obj)
                            )
                        } else {
                            _this.$message.error('获取倾倒点坐标失败！')
                        }
                    },
                    (err) => {
                        _this.$message.error(
                            '获取倾倒点坐标失败！请联系管理员！'
                        )
                    }
                )
            }
        },
    },
    created() {
        let _this = this
        //获取预警数据
        setTimeout(() => {
            _this.getWarningData()
            setInterval(() => {
                _this.getWarningData()
            }, 60000)
        }, 2000)

        //定时请求
        setInterval(() => {
            this.getWarningList()
        }, 15000)

        this.initData()
        this.getXzList()
        // 获取倾倒点
        setTimeout(() => {
            this.getQddGps()
            this.getAllCLSBList()
        }, 2000)
    },
    mounted() {},
}
</script>



// WEBPACK FOOTER //
// src/App.vue